<template>
  <div>
  <form class="background" @keyup.enter.native="login">
    <div
    v-if="!resetDisable"
      class="Rectangle"
      id="login"
      :style="{ transform: `translateY(calc(50vh - 50%))`}" 
    >
      <img style="width: 50%!important; margin-top: 30px!important; margin-bottom: 10px!important" class="one-inventory" src="@/assets/ezcms.png" alt /> 
      <p class="title">Extranet Reset Password</p>
      <div>
        <label class="label-input">{{ $t("_REGISTER.CREATE_PASSWORD") }}</label>
        <input-text
          class="password"
          :type="passwordInput.type"
          :placeholder="$t('_REGISTER.CREATE_PASSWORD')"
          :error="errorPassword.retypeNewPassword.error"
          :model.sync="user.newPassword"
        >
          <div class="icon" slot="icon">
            <span
              v-if="passwordInput.isShowed"
              class="icon icon-eye-disabled icon--grey--opacity"
              @click="toggleShowPassword"
            ></span>
            <span
              v-if="!passwordInput.isShowed"
              class="icon icon-eye icon--grey--opacity"
              @click="toggleShowPassword"
            ></span>
            <span v-if="errorPassword.retypeNewPassword.error" class="icon icon-Error icon--red"></span>
          </div>
        </input-text>
      </div>
      <div>
        <label class="label-input">{{ $t("_REGISTER.RETYPE_PASSWORD") }}</label>
        <input-text
          class="password"
          :type="passwordInput.type"
          :placeholder="$t('_REGISTER.RETYPE_PASSWORD')"
          :error="errorPassword.retypeNewPassword.error"
          :model.sync="user.retypeNewPassword"
        >
          <div class="icon" slot="icon">
            <span
              v-if="passwordInput.isShowed"
              class="icon icon-eye-disabled icon--grey--opacity"
              @click="toggleShowPassword"
            ></span>
            <span
              v-if="!passwordInput.isShowed"
              class="icon icon-eye icon--grey--opacity"
              @click="toggleShowPassword"
            ></span>
            <span v-if="errorPassword.retypeNewPassword.error" class="icon icon-Error icon--red"></span>
          </div>
        </input-text>
      </div>
      <a class="login" :class="{ active: isReady }" @click="validatePassword">
        <span>
          {{ $t("_LOGIN.RESET") }}
          <v-icon>arrow_forward</v-icon>
        </span>
      </a>
    </div>
    <div
      v-if="resetDisable"
      class="Rectangle"
      id="login"
      :style="{ transform: `translateY(calc(50vh - 50%))`}" 
      >
      <h1 style="color:white; margin-top:50%">{{ $t("_RESET.NOT_VALID_REQUEST") }}</h1>
    </div>
    <span v-if="tip" class="ex-tip">{{tip}}</span>
  </form>
  </div>
</template>

<script>
import Input from "@/components/Utils/Input.vue";
import { authenticationService } from "@/_services/";
import { service } from "@/_services/Account/Setting/account-setting.service.js"
import { _validateEmail, _alert } from "@/_helpers/function.js";
import VueRecaptcha from 'vue-recaptcha';
const MODAL_WIDTH = 500;
const MODAL_HEIGHT = 376;
export default {
  components: {
    "input-text": Input,
    VueRecaptcha
  },
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      modalHeight: MODAL_HEIGHT,
      scale: 1,
      passwordInput: {
        type: "password",
        isShowed: false
      },
			loginForm: {
				recaptchaVerified: false,
				pleaseTickRecaptchaMessage: '',
      },
      errorPassword: {
        retypeNewPassword: {
          error: false,
          message: ""
        }
      },
      user: {
      retypeNewPassword: "",
      newPassword: ""
      },
      resetDisable: false,
      token: ""
    };
  },
  created() {
    let vm = this;
    if (this.$route.query.token) {
      this.token = this.$route.query.token;
      this.resetDisable = false;
    } else {
      this.resetDisable = true;
    }
    window.addEventListener("keyup", function(e) {
      if (e.keyCode == 13) {
        vm.resetPass();
      }
    });
  },
  watch: {
    user: {
      handler(val) {
        this.resetPassFail = false;
      },
      deep: true
    },
    passwordInput: {
      handler(val) {
        this.passwordInput.type = val.isShowed ? "text" : "password";
      },
      deep: true
    },
    translateXForm(value) {
      if (window.innerHeight - this.formHeight < 60) {
        this.scale = (window.innerHeight - 60) / this.formHeight;
      }
    }
  },
  computed: {
    isReady() {
      return this.user.newPassword.length >= 6 && this.user.retypeNewPassword.length >= 6;
    }
  },
  methods: {
    // Validate password, if valid then call updatePassword()
    validatePassword() {
      if (this.user.newPassword !== this.user.retypeNewPassword) {
        const errorMessage = this.$t(
          "_ACCOUNT_SETTING.ERROR_PASSWORD_NOT_MATCH"
        );
        this.errorPassword.retypeNewPassword.error = true;
        this.errorPassword.retypeNewPassword.message = errorMessage;
        _alert(null, errorMessage, false);
        return false;
      }
      this.updatePassword();
    },
    // Update password
    updatePassword() {
      let temp = {
        newPassword: this.user.newPassword,
        token: this.token
      };
      this.isLoading = true;
      service
        .resetPassword(temp)
        .then(res => {
          if (res) {
            if (res.responseCode === 0) {
              // Logout and redirect to login page
              _alert(res, this.$t(res.data), false);
              authenticationService.logout(false);
              this.$router.push({ name: "login" });
            }
            _alert(res, this.$t(res.data), false);
          }
        })
        .finally(() => (this.isLoading = false));
    },
    toggleShowPassword() {
      this.passwordInput.isShowed = !this.passwordInput.isShowed;
    }
  }
};
</script>